export const ICLFcfGraphMock = {
  title: 'ICL FCF',
  type: 'ICL_FCF',
  navigation: {
    type: 'GraphViews',
    nav: [
      {
        title: 'C',
        graph: {
          data: [
            { title: 'IP', value: 94 },
            { title: 'POTASH', value: -28 },
            { title: 'PS', value: -10 },
            { title: 'IAS', value: 6 },
            { title: 'OTHER', value: -3 },
            { title: 'OPERATING FCF', value: -99 },
            { title: 'TAX REFUNDS', value: 6 },
            { title: 'INTEREST PAYMENT', value: -99 },
            { title: 'DERIVATIVES RECEIVED', value: -99 },
            { title: 'FREE CASH FLOW', value: -59 },
            { title: 'DIVIDEND', value: -34 },
          ],
        },
      },
    ],
  },
};
